export default "__VITE_ASSET__d606ac1e__"